// extracted by mini-css-extract-plugin
module.exports = {"manageOrder":"ManageOrder_manageOrder__2FqnP","button":"ManageOrder_button__3y5w0"};